import { useEffect, useState } from "react";
import { doc, getDoc, setDoc, updateDoc } from "@firebase/firestore";
import { db } from "../firebase/firebase";

export const useVisitorCount = () => {
  const [visitCount, setVisitCount] = useState(0);

  useEffect(() => {
    const incrementVisitorCount = async () => {
      const visitCountRef = doc(db, "visitCount", "count");
      const visitCountSnap = await getDoc(visitCountRef);
      if (!visitCountSnap.exists()) {
        await setDoc(visitCountRef, { value: 1 });
        setVisitCount(1);
      } else {
        const newValue = visitCountSnap.data().value + 1;
        await updateDoc(visitCountRef, { value: newValue });
        setVisitCount(newValue);
      }
    };
    incrementVisitorCount();
  }, []);

  return visitCount;
};
